<template>
  <div
      :class="
        $attrs.class ||
        twMerge(
          'w-full',
          appendClass
        )
      "
      :id="random_id"
      :data-testid="props.dataTestid"
  >
    <slot>
      <TsSwiper pagination wrap :items-to-show="slidesToShow" :autoplay="autoPlay">
        <slot name="slide">
          <Slide v-for="(slide, index) in data" :key="slide.id">
            <TsCard appendClass="w-fit max-w-sm border-0 shadow-none p-0"
                    :data-testid="`${props.dataTestid}-card-${index}`">
              <NuxtLink :to="slide.link" :data-testid="`${props.dataTestid}-image-${index}`">
                <div class="flex justify-center">
                  <div
                      class="w-full flex cursor-pointer justify-center relative overflow-hidden rounded-xl">
                      <TsImage
                          class="w-full"
                          v-if="slide.image"
                          :src="slide.image"
                          :alt="slide.imageAltText"
                          :data-testid="`${props.dataTestid}-slide-image-${index}`"
                          @click="emit('imageClicked',slide)"
                          loading="lazy"
                      />
                  </div>
                </div>
              </NuxtLink>
              <div class="flex p-1 py-3">
                <div class="w-fit text-justify">
                    <div :data-testid="`${props.dataTestid}-card-description-${index}`"
                         v-html="slide.description"></div>
                </div>
              </div>

              <div class="flex w-fit  gap-2">
                  <TsButton :label="slide.buttonLabel" size="xs" outlined rounded :data-testid="`${props.dataTestid}-read-more`"
                            @click="emit('readMore', slide)" :link="slide.readMoreLink"
                  />
              </div>
            </TsCard>
          </Slide>
        </slot>
      </TsSwiper>
    </slot>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";

const TsSwiper = defineAsyncComponent(
    () => import('~/components/organisms/TsSwiper.vue')
);

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);


const emit = defineEmits(['imageClicked', 'readMore'])
const random_id = ref("");
onMounted(() => {
  random_id.value = useRandomUUID();
});

type Slide = {
  link?: string;
  image?: string;
  imageAltText?: string;
  description?: string;
  readMoreLink?: string;
  buttonLabel?: string;
}

type Props = {
  data?: Slide[];
  dataTestid?: string;
  appendClass?: string;
  slidesToShow?: number;
  autoPlay?:boolean;
}
//@ts-ignore
const props = withDefaults(defineProps<Props>(), {
  data: [
    {
      id: '1',
      link: '#',
      image: 'https://placehold.co/300x200',
      description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      readMoreLink: '#',
      buttonLabel: 'Read More'
    },
    {
      id: '2',
      link: '#',
      image: 'https://placehold.co/300x200',
      description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      readMoreLink: '#',
      buttonLabel: 'Read More'
    },
    {
      id: '3',
      link: '#',
      image: 'https://placehold.co/300x200',
      description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      readMoreLink: '#',
      buttonLabel: 'Read More'
    },
  ],
  slidesToShow: 3,
  autoPlay: true
});

</script>
